import { createMuiTheme } from "@material-ui/core/styles";
import purple from "@material-ui/core/colors/purple";
import green from "@material-ui/core/colors/green";

export const getTheme = ({ type, primary, secondary }) => {
  return createMuiTheme({
    // palette: {
    //   primary: primary || purple,
    //   secondary: secondary || green,
    //   type: type || "light",
    // },
    palette: {
      primary: {
        main: primary || purple,
      },
      secondary: {
        main: secondary || green,
      },
      type: type || "light",
    },
    status: {
      danger: "orange",
    },
    typography: {
      //   htmlFontSize: 10,
      fontSize: 12,
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
    },
  });
};
